import NumberFlow, { continuous, type Format } from "@number-flow/react";
import type { ClassNameProps } from "../types";

/** Props Interface */
export interface AnimatedNumberProps extends ClassNameProps {
	value: number;
	prefix?: string;
	suffix?: string;
	format?: Format;
	continuous?: boolean;
}

export function AnimatedNumber({
	value,
	className,
	prefix,
	suffix,
	format,
	continuous: _continuous = true,
}: AnimatedNumberProps) {
	/** Plugins */
	const plugins = _continuous ? [continuous] : [];

	/** Render */
	return (
		<NumberFlow
			value={value}
			className={className}
			prefix={prefix}
			suffix={suffix}
			plugins={plugins}
			format={format}
			locales={"de-DE"}
		/>
	);
}
